import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsGet } from 'services/WService';
import { formatDate } from 'hooks/Pipe';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Fecha', accessor: 'updated_at', width: 200 },
  { Header: 'Tipo', accessor: 'update_type', width: 120 },
  { Header: 'Usuario', accessor: 'name', width: 150 },
  { Header: 'P.unitario nuevo', accessor: 'unit_price' },
  { Header: 'P.unitario antiguo', accessor: 'unit_price_old' },
  { Header: 'P.paquete nuevo', accessor: 'package_price' },
  { Header: 'P.paquete antiguo', accessor: 'package_price_old' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function PriceLogModal(props) {
  const [priceLogs, setPriceLogs] = useState([]);

  async function getData() {
    let res = await wsGet('logi/price', props.model.id);
    if (res.success) {
      setPriceLogs(res.data.logs);
    }
  }

  function setOpen() {
    props.setOpen({ open: false });
  }

  useEffect(() => {
    if (props.model === undefined){
      setPriceLogs([]);
      return;
    }
    getData();
  }, [props.model]);

  return (
    <Modal
      title={`${props.model.ListName} - ${props.model.ItemName} (${props.model.ItemCode})`}
      maxWidth="lg"
      fullWidth
      model={props.model}
      setOpen={setOpen}
      entity=""
      disabledSave
    >
      <ReactTable
        columns={columns}
        data={priceLogs.map((log, index) => {
          return {
            num: index + 1,
            ...log,
            update_type: log.update_type || 'Indeterminado',
          };
        })}
      />
    </Modal>
  );
}

export default PriceLogModal;
